import React from "reactn";
import { BoxForm, formTypes } from "../../../../components/UI/form";
import ProgramSearchInput from "../../../../components/common/ProgramSearchInput";
import {
  hasValidOrganizationCoordinates,
  parseOrganizationAddressSuggestion
} from "../../../../lib/organizationAddress";

class SectionOne extends React.PureComponent {
  constructor(props) {
    super(props);
    const organizationInfo = this.global.organizationInfo || {};
    this.state = {
      addressError: "",
      manualAddress:
        Boolean(organizationInfo.address1) &&
        !hasValidOrganizationCoordinates(organizationInfo)
    };
  }
  handleChange = (e, v) => {
    const changesAddressLocation = [
      "address1",
      "city",
      "province",
      "postalcode",
      "country"
    ].includes(e);

    if (changesAddressLocation && !this.state.manualAddress) {
      this.setState({ manualAddress: true, addressError: "" });
    }
    if (
      (changesAddressLocation || e === "address2") &&
      this.props.onAddressChange
    ) {
      this.props.onAddressChange();
    }

    this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        [e]: v,
        ...(changesAddressLocation
          ? { main_lat: null, main_long: null }
          : {})
      }
    });
  };

  useManualAddress = () => {
    this.setState({ manualAddress: true, addressError: "" });
    if (this.props.onAddressChange) this.props.onAddressChange();
    this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        main_lat: null,
        main_long: null
      }
    });
  };

  useAddressSearch = () => {
    this.setState({ manualAddress: false, addressError: "" });
    if (this.props.onAddressChange) this.props.onAddressChange();
  };

  handleAddressSelect = (formattedAddress, location, suggestion) => {
    const address =
      formattedAddress &&
      parseOrganizationAddressSuggestion(suggestion, location);

    if (!address) {
      this.setState({
        addressError: "Please select a complete street address from the suggestions."
      });
      return;
    }

    this.setState({ addressError: "", manualAddress: false });
    if (this.props.onAddressChange) this.props.onAddressChange();
    this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        ...address
      }
    });
  };

  getManualAddressHelpText = () => {
    switch (this.props.addressGeocodeStatus) {
      case "mapping":
        return "Trying to map this address...";
      case "mapped":
        return "Address mapped successfully. Your typed address was kept unchanged.";
      case "unavailable":
        return "We couldn't map this address. It will still be shown as text.";
      default:
        return "We'll try to map this address when you save. If that fails, it will still be shown as text.";
    }
  };

  customForm = () => {
    return (
      <div className="formbody">
        <form>
          <div className="row">
            <div className="col-5">
              <h3>
                Organization Title<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="organization_title"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.organization_title}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Address Line 1<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                {this.state.manualAddress ? (
                  <input
                    name="address1"
                    placeholder="Street address"
                    onChange={e =>
                      this.handleChange(e.target.name, e.target.value)
                    }
                    value={this.global.organizationInfo.address1 || ""}
                  />
                ) : (
                  <ProgramSearchInput
                    placeholder="Search for your address"
                    noicon={true}
                    name="search"
                    style={{ marginTop: "0px" }}
                    value={this.global.organizationInfo.address1}
                    gLoc={this.handleAddressSelect}
                  />
                )}
                <small
                  style={{
                    color: this.state.addressError ? "#dc3545" : "#797979",
                    display: "block"
                  }}
                >
                  {this.state.manualAddress
                    ? this.getManualAddressHelpText()
                    : this.state.addressError ||
                      "Select an address from the suggestions to set its map location."}
                </small>
                <button
                  type="button"
                  onClick={
                    this.state.manualAddress
                      ? this.useAddressSearch
                      : this.useManualAddress
                  }
                  style={{
                    background: "none",
                    border: 0,
                    color: "#007bff",
                    cursor: "pointer",
                    padding: "6px 0",
                    textDecoration: "underline"
                  }}
                >
                  {this.state.manualAddress
                    ? "Search for an address instead"
                    : "Can't find your address? Enter it manually"}
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>Address Line 2</h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="address2"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.address2}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                City<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="city"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.city}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Region / Province<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="province"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.province}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Postal / Zip<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="postalcode"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.postalcode}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Country<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <input
                  name="country"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.country}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>Target Ages</h3>
            </div>
            <div className="col-7 d-flex">
              <formTypes.ChildAgeGroupSelect
                value={
                  this.global.organizationInfo.target_ages.map(e =>
                    typeof e === "string" ? JSON.parse(e) : e
                  ) || []
                }
                onChange={(_, value) =>
                  this.handleChange(
                    "target_ages",
                    value.map(e => ({
                      name: e.name
                    }))
                  )
                }
              ></formTypes.ChildAgeGroupSelect>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Classification<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <select
                  className="input-fields"
                  style={{ width: "100%" }}
                  name="classification"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.classification}
                >
                  <option value="">Please Select</option>
                  <option value="Academics">Academics</option>
                  <option value="After School">After School</option>
                  <option value="Arts">Arts</option>
                  <option value="Athletics">Athletics</option>
                  <option value="Before & After School">
                    Before & After School
                  </option>
                  <option value="Camps">Camps</option>
                  <option value="Cooking">Cooking</option>
                  <option value="Creative">Creative</option>
                  <option value="Dance">Dance</option>
                  <option value="Daycare / Preschool">
                    Daycare / Preschool
                  </option>
                  <option value="Drama">Drama</option>
                  <option value="Exercise">Exercise</option>
                  <option value="Facilities (Rec Centre)">
                    Facilities (Rec Centre)
                  </option>
                  <option value="Faith">Faith</option>
                  <option value="Language / Culture">Language / Culture</option>
                  <option value="Leadership">Leadership</option>
                  <option value="Life Skills">Life Skills</option>
                  <option value="Mixed">Mixed</option>
                  <option value="Music">Music</option>
                  <option value="Outdoors">Outdoors</option>
                  <option value="Playgrounds">Playgrounds</option>
                  <option value="Service Volunteer">Service Volunteer</option>
                  <option value="STEM">STEM</option>
                  <option value="Special Needs">Special Needs</option>
                  <option value="Theatre">Theatre</option>
                  <option value="Tutoring">Tutoring</option>
                </select>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <h3>
                Format<span className="requiredField">*</span>
              </h3>
            </div>
            <div className="col-7 d-flex">
              <div className={`w-100`}>
                <select
                  className="input-fields"
                  style={{ width: "100%" }}
                  name="format"
                  onChange={e =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  value={this.global.organizationInfo.format}
                >
                  <option value="">Please Select</option>
                  <option value="In-Person">In-Person</option>
                  <option value="Online">Online</option>
                  <option value="Both">Both</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };

  render() {
    return (
      <BoxForm
        handleChange={this.handleChange}
        name={"Organization Info"}
        customForm={this.customForm()}
      />
    );
  }
}

export default SectionOne;
